<template>
  <section class="section">
    <div class="section__content --centered">
      <HeadingBlock :content="content" />
      <div class="category__card-group">
        <CategoryCard
          :category="category"
          v-for="(category, categoryIndex) in $store.state.categories.items"
          :key="category.id"
          v-reveal="{ delay: 50 * categoryIndex + 250 }"
        />
      </div>
      <CTABlock :content="content.cta[0]" v-if="content.cta.length" />
    </div>
  </section>
</template>

<script>
import { CTABlock, HeadingBlock } from '@/components/blocks'
import { CategoryCard } from '@/components/cards'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'CategoriesSection',
  mixins: [DefaultSectionProps],
  components: { CategoryCard, CTABlock, HeadingBlock },
}
</script>
